<template lang="html">
  <section
    class="search-settings py-1"
    :class="{
      'bg-white': showSettings,
      'with-border-top': searchModel === 'tavnit' && !mobile,
    }"
  >
    <!-- TODO: Remove after semantic support-->
    <div
      class="d-flex justify-content-between px-2 position-relative"
      style="cursor: pointer"
      @click="toggleSettings"
    >
      <h3 class="m-0" :class="{ 'text-primary': showSettings }">
        {{ hebrew ? "מאפייני מילה" : "Settings" }}
        <small
          style="font-size: 7px; top: -3px"
          class="position-relative"
          v-if="morphChanges"
        >
          <i class="text-primary fas fa-circle"></i>
        </small>
      </h3>
      <i
        v-if="showSettings"
        class="fas fa-sort-up text-primary"
        style="margin-top: 6px"
      ></i>
      <i v-if="!showSettings" class="fas fa-sort-down"></i>
    </div>
    <div class="settings-wrap px-2 py-3" v-if="showSettings">
      <div class="dropdowns">
        <div class="row">
          <div id="pos" class="col-6">
            <small class="mb-1">חלק דיבור</small>
            <dicta-dropdown
              v-model="posIndex"
              display-field="display"
              :options="posChoices"
              class="d-dropdown w-100"
            ></dicta-dropdown>
          </div>
          <div id="gender" class="col-6">
            <small class="my-1">מין</small>
            <dicta-dropdown
              v-model="genderIndex"
              display-field="display"
              :options="genderChoices"
              class="d-dropdown w-100"
            ></dicta-dropdown>
          </div>
        </div>
        <div class="row mt-2">
          <div id="person" class="col-6">
            <small class="my-1">גוף</small>
            <dicta-dropdown
              v-model="personIndex"
              display-field="display"
              :options="personChoices"
              class="d-dropdown w-100"
            ></dicta-dropdown>
          </div>
          <div id="number" class="col-6">
            <small class="my-1">מספר</small>
            <dicta-dropdown
              v-model="numberIndex"
              display-field="display"
              :options="numberChoices"
              class="d-dropdown w-100"
            ></dicta-dropdown>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-6" id="status">
            <small class="my-1">סמיכות</small>
            <dicta-dropdown
              v-model="statusIndex"
              display-field="display"
              :options="statusChoices"
              class="d-dropdown w-100"
            ></dicta-dropdown>
          </div>
          <div id="tense" class="col-6">
            <small class="my-1">זמן</small>
            <dicta-dropdown
              v-model="tenseIndex"
              display-field="display"
              :options="tenseChoices"
              class="d-dropdown w-100"
            ></dicta-dropdown>
          </div>
        </div>
        <div class="row mt-2">
          <div id="suffix" class="col-6">
            <small class="my-1">סיומת</small>
            <dicta-dropdown
              v-model="suffixIndex"
              display-field="display"
              :options="suffixChoices"
              class="d-dropdown w-100"
            ></dicta-dropdown>
          </div>
          <div
            id="suffix-number"
            v-if="suffixChoices.indexOf(suffixIndex) == 1"
            class="col-6"
          >
            <p class="my-1">סיומת-מספר</p>
            <dicta-dropdown
              v-model="suffixNumberIndex"
              display-field="display"
              :options="suffixNumberChoices"
              class="d-dropdown w-100"
            ></dicta-dropdown>
          </div>
        </div>
        <div class="row mt-2">
          <div
            id="suffix-gender"
            class="col-6"
            v-if="suffixChoices.indexOf(suffixIndex) == 1"
          >
            <p class="my-1">סיומת-מין</p>
            <dicta-dropdown
              v-model="suffixGenderIndex"
              display-field="display"
              :options="suffixGenderChoices"
              class="d-dropdown w-100"
            ></dicta-dropdown>
          </div>
          <div
            id="suffix-person"
            class="col-6"
            v-if="suffixChoices.indexOf(suffixIndex) == 1"
          >
            <p class="my-1">סיומת-גוף</p>
            <dicta-dropdown
              v-model="suffixPersonIndex"
              display-field="display"
              :options="suffixPersonChoices"
              class="d-dropdown w-100"
            ></dicta-dropdown>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="js">
  import {BlankState, Actions} from '@/store/stateChanges'

  export default  {
  name: 'SearchSettings',
  props: [],
  data() {
    return {
      showSettings: false,
      posChoices: [
        { value: 0, display: 'הכל' },
        { value: 1, display: 'שם עצם' },
        { value: 2, display: 'שם תואר' },
        { value: 3, display: 'פועל' },
        { value: 4, display: 'תואר הפועל' },
        { value: 5, display: 'מילות יחס' },
        { value: 6, display: 'מילות קישור' },
        { value: 7, display: 'כינויי רמז' }
      ],
      genderChoices: [{ value: 0, display: 'הכל' },{ value: 1, display: 'זכר'},{ value: 2, display: 'נקבה' }],
      numberChoices: [{ value: 0, display: 'הכל' },{ value: 1, display: 'יחיד'},{ value: 2, display: 'רבים' }],
      personChoices: [{ value: 0, display: 'הכל' },{ value: 1, display: 'מדבר'},{ value: 2, display: 'נוכח' },{ value: 3, display: 'נסתר' }],
      statusChoices: [{ value: 0, display: 'הכל' },{ value: 1, display: 'נפרד'},{ value: 2, display: 'נסמך' }],
      tenseChoices: [
        { value: 0, display: 'הכל' },
        { value: 1, display: 'עבר'},
        { value: 2, display: 'הווה' },
        { value: 0, display: 'עתיד' },
        { value: 1, display: 'ציווי'},
        { value: 2, display: 'מקור' }
      ],
      suffixChoices: [{ value: 0, display: 'הכל' },{ value: 1, display: 'כן'},{ value: 2, display: 'לא' }],
      suffixGenderChoices: [{ value: 0, display: 'הכל' },{ value: 1, display: 'זכר'},{ value: 2, display: 'נקבה' }],
      suffixNumberChoices: [{ value: 0, display: 'הכל' },{ value: 1, display: 'יחיד'},{ value: 2, display: 'רבים' }],
      suffixPersonChoices: [{ value: 0, display: 'הכל' },{ value: 1, display: 'מדבר'},{ value: 2, display: 'נוכח' },{ value: 3, display: 'נסתר' }]
    }
  },
  methods: {
    toggleSettings() {
      this.showSettings = !this.showSettings
    }
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew
    },
    searchModel () {
      return this.$store.state.searchModel
    },
    mobile () {
      return this.$mq === 'xs'
    },
    morphChanges () {
      return JSON.stringify(BlankState.morph) !==  JSON.stringify(this.$store.state.morph)
    },
    genderIndex: {
      get () {
        return this.genderChoices[this.$store.state.morph.genderIndex]
      },
      set (value) {
        this.$store.commit('SET_GENDER', this.genderChoices.indexOf(value))
        this.$store.dispatch(Actions.RUN_CHARUZIT)
      }
    },
    personIndex: {
      get () {
        return this.personChoices[this.$store.state.morph.personIndex]
      },
      set (value) {
        this.$store.commit('SET_PERSON', this.personChoices.indexOf(value))
        this.$store.dispatch(Actions.RUN_CHARUZIT)
      }
    },
    numberIndex: {
      get () {
        return this.numberChoices[this.$store.state.morph.numberIndex]
      },
      set (value) {
        this.$store.commit('SET_NUMBER', this.numberChoices.indexOf(value))
        this.$store.dispatch(Actions.RUN_CHARUZIT)
      }
    },
    posIndex: {
      get () {
        return this.posChoices[this.$store.state.morph.posIndex]
      },
      set (value) {
        this.$store.commit('SET_POS', this.posChoices.indexOf(value))
        this.$store.dispatch(Actions.RUN_CHARUZIT)
      }
    },
    tenseIndex: {
      get () {
        return this.tenseChoices[this.$store.state.morph.tenseIndex]
      },
      set (value) {
        this.$store.commit('SET_TENSE', this.tenseChoices.indexOf(value))
        this.$store.dispatch(Actions.RUN_CHARUZIT)
      }
    },
    statusIndex: {
      get () {
        return this.statusChoices[this.$store.state.morph.statusIndex]
      },
      set (value) {
        this.$store.commit('SET_STATUS', this.statusChoices.indexOf(value))
        this.$store.dispatch(Actions.RUN_CHARUZIT)
      }
    },
    suffixIndex: {
      get () {
        return this.suffixChoices[this.$store.state.morph.suffixIndex]
      },
      set (value) {
        this.$store.commit('SET_SUFFIX', this.suffixChoices.indexOf(value))
        this.$store.dispatch(Actions.RUN_CHARUZIT)
      }
    },
    suffixGenderIndex: {
      get () {
        return this.suffixGenderChoices[this.$store.state.morph.suffixGenderIndex]
      },
      set (value) {
        this.$store.commit('SET_GENDER_SUFFIX', this.suffixGenderChoices.indexOf(value))
        this.$store.dispatch(Actions.RUN_CHARUZIT)
      }
    },
    suffixPersonIndex: {
      get () {
        return this.suffixPersonChoices[this.$store.state.morph.suffixPersonIndex]
      },
      set (value) {
        this.$store.commit('SET_PERSON_SUFFIX', this.suffixPersonChoices.indexOf(value))
        this.$store.dispatch(Actions.RUN_CHARUZIT)
      }
    },
    suffixNumberIndex: {
      get () {
        return this.suffixNumberChoices[this.$store.state.morph.suffixNumberIndex]
      },
      set (value) {
        this.$store.commit('SET_NUMBER_SUFFIX', this.suffixNumberChoices.indexOf(value))
        this.$store.dispatch(Actions.RUN_CHARUZIT)
      }
    }
  }
}
</script>
<style scoped>
.with-border-top {
  border-top: 1px solid #c8c8c8;
}
</style>
